// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/Auth/authSlice';
import userReducer from '../features/Users/userSlice';
import languageReducer from '../features/Languages/languageSlice';
import serviceReducer from '../features/Services/serviceSlice';
import translatorReducer from '../features/Translators/translatorSlice';
import projectReducer from '../features/Projects/projectSlice';
import pendingProjectReducer from '../features/Projects/pendingProjectSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    languages: languageReducer,
    services: serviceReducer,
    translators: translatorReducer,
    projects: projectReducer,
    pendingProjects: pendingProjectReducer,
    // Add other reducers here if needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable if you have non-serializable values in actions
    }),
});

export default store;